import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { LoadingMaskService } from '../../../shared/loading-mask/loading-mask.service';
import { LogoService, Logo } from './logo.service';
import { CommonFiltersResolve } from '../filters/common-filters-resolve';
import { ActiveFiltersService } from '../filters/active-filters.service';

@Injectable()
export class LogoResolve extends CommonFiltersResolve implements Resolve<Logo[]> {
	constructor(private service: LogoService,
	            private activeFiltersService: ActiveFiltersService,
	            private mask: LoadingMaskService) {
		super(activeFiltersService);
	}

	resolve(route: ActivatedRouteSnapshot): Promise<Logo[]> {
		this.mask.addLoading();
		let filters: any = this.initActiveFiltersFromURLParams(route);
		return this.service.getLogo(filters)
			.then((orders: Logo[]) => {
				this.mask.removeLoading();
				return orders;
			});
	}
}
